/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

import Provider, { createProvider } from './components/Provider';
import connectAdvanced from './components/connectAdvanced';
import connect from './connect/connect';

export { Provider, createProvider, connectAdvanced, connect };



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux/es/index.js
// module id = 474
// module chunks = 76